'use strict'

export default class AddConfController {

  /*@ngInject*/
  constructor ($http, $state, $stateParams, $scope, toaster) {
    this.$http = $http
    this.$state = $state
    this.$stateParams = $stateParams
    this.$scope = $scope
    this.toaster = toaster
  }

  $onInit () {
    this.getConf(this.$stateParams.id)
  }

  getConf (id) {
    this.$http.get('/api/deviceconfigs/' + id).then(response => {
      this.conf = response.data
    })
  }

  save () {
    this.$http.put(`api/deviceconfigs/${this.$stateParams.id}`, this.conf).then(response => {
      this.$state.go('deviceconfigs.show', {
        id: this.$stateParams.id
      })
    })
  }
}



// WEBPACK FOOTER //
// ./client/app/deviceconfigs/edit/edit.controller.js